import type { PortableTextBlock } from "@portabletext/types";
import type { Document, EnergyCertificate, ImageWithMeta, Table, Question } from "./shared";

export const productCategoryMapping: { key: ProductCategory; value: string; }[] = [
  {
    key: "varmepumpe",
    value: "Varmepumpe",
  },
  {
    key: "elbillader",
    value: "Elbillader",
  },
  {
    key: "varmtvannsbereder",
    value: "Varmtvannsbereder",
  },
  {
    key: "elektriker",
    value: "Elektriker",
  },
  {
    key: "gavekort",
    value: "Gavekort",
  },
];
export type ProductCategory =
  | "varmepumpe"
  | "elbillader"
  | "elektriker"
  | "varmtvannsbereder"
  | "gavekort"
  | "hus-og-hjem"
  | "bilen";

export type ProductCategoryPage = {
  product_category: ProductCategory;
  title: string;
  image: ImageWithMeta;
  subtitle: string;
  description: string;
  additional_content: PortableTextBlock[];
};

export type AlternativeVariant = {
  title: string;
  sortString: string;
  current?: boolean;
  slug: {
    current: string | null;
  };
  firstImage: ImageWithMeta;
};

export type Product = {
  _id?: string;
  product_categories: ProductCategory[];
  title: string;
  not_available?: boolean;
  typeform_name: string;
  typeform_id: string;
  campaign?: string;
  slug: {
    current: string | null;
  };
  additional_category?: string;
  images: ImageWithMeta[];
  thumbnails?: ImageWithMeta[];
  alternative_variants?: AlternativeVariant[];
  description_title: string;
  description_short: string;
  description: string;
  content: PortableTextBlock[];
  additional_content?: PortableTextBlock[];
  price: number;
  down_payment: number;
  functions: PortableTextBlock[];
  specifications: Table;
  documents: Document[];
  energy_certificate?: EnergyCertificate;
  heat_efficiency?: PortableTextBlock[];
  faq?: {
    heading: string;
    items: Question[];
  };
  related_products?: Product[];
};

export type ProductTerm = {
  additional_category?: string;
  product_category: ProductCategory;
  title: string;
  lead: string;
  content: PortableTextBlock[];
  documents?: Document[];
};

export type ProductCondition = {
  product_category: ProductCategory;
  additional_category?: string;
  title: string;
  lead: string;
  content: PortableTextBlock[];
  documents?: Document[];
};

export type ProductCategoryArticle = {
  product_category: ProductCategory;
  title: string;
  lead: string;
  content: PortableTextBlock[];
  image: ImageWithMeta;
};

export type Nettbutikk = {
  title: string;
  description: string;
  category_pages_image: (ImageWithMeta & { category: ProductCategory; });
  teaser: {
    title: string;
    description: string;
  };
};
